import { render, staticRenderFns } from "./ProfileSettingsPage.vue?vue&type=template&id=1debcd19&scoped=true"
import script from "./ProfileSettingsPage.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./ProfileSettingsPage.vue?vue&type=style&index=0&id=1debcd19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1debcd19",
  null
  
)

export default component.exports